export default {
  ITEM: "attr"
};



// WEBPACK FOOTER //
// ./src/components/CreateSurvey/SelectAttr/ItemTypes.js